import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
import ResetAccountPw from "./resetpw";
import EditAccTab from "./editacctab";
import { format } from "date-fns";
import {
  ActiveIcon,
  AddIcon,
  EditIcon,
  InActiveIcon,
  ResetPWIcon,
} from "@/assets/icons/admin";
import { useGetAllUsers } from "@/services/admin.service";
import { AdminRegistration } from "@/types";
import AddAccount from "../addAccount";
import Datatable from "@/components/tables/datatable";

const columns = [
  { key: "no", label: "No" },
  { key: "userName", label: "Username", sortable: true },
  { key: "fullName", label: "Fullname", sortable: true },
  { key: "email", label: "Email", sortable: true },

  { key: "group", label: "Group" },
  { key: "status", label: "Status", sortable: true },
  { key: "createdAt", label: "Create Date", sortable: true },
  { key: "lastLogin", label: "Last Login", sortable: true },
  { key: "action", label: "Action" },
];

const fields = [
  { label: "Username", value: "userName" },
  { label: "Email", value: "email" },
  { label: "Last IP", value: "lastIP" },
];

const AccountList = () => {
  const query = useGetAllUsers;

  const [isResettingPw, setIsResettingPw] = useState(false);
  const [editItemId, setResetPasswordItemId] = useState("");

  const handlePasswordClick = (itemId: any) => {
    setIsResettingPw(true);
    setResetPasswordItemId(itemId);
    console.log(editItemId);
  };

  const handleCancelEdit = () => {
    setIsResettingPw(false);
    setResetPasswordItemId("");
  };

  const [isEditingAcc, setIsEditingAcc] = useState(false);
  const [editAccItemData, setEditACCItemData] = useState<AdminRegistration>();

  const handleEditClick = (itemId: any) => {
    setIsEditingAcc(true);
    setEditACCItemData(itemId);
  };

  const handleCancelEditAcc = () => {
    setIsEditingAcc(false);
    setEditACCItemData(undefined);
  };

  const [isAddingNewAccount, setIsAddingNewAccount] = useState(false);

  const handleAddNewAccountClick = () => {
    setIsAddingNewAccount(true);
  };

  const handleAddNewAccountCancel = () => {
    setIsAddingNewAccount(false);
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "status":
        return (
          <div className="flex items-center">
            {item.status === "ACTIVE" ? (
              <span>
                <ActiveIcon />
              </span>
            ) : (
              <span>
                <InActiveIcon />
              </span>
            )}
          </div>
        );
      case "action":
        return (
          <div className="flex items-center">
            <Button
              onClick={() => handleEditClick(item)}
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <EditIcon />
            </Button>
            <Button
              onClick={() => handlePasswordClick(item.id)}
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <ResetPWIcon />
            </Button>
          </div>
        );
      case "no":
        return (
          <div className="font-bold">
            {" "}
            {data.findIndex((row: any) => row?.id === item?.id) + 1 + "."}
          </div>
        );
      case "userName":
        return (
          <div className="tb-data-blue font-bold">
            {getKeyValue(item, columnKey) ?? "-"}
          </div>
        );
      case "fullName":
        return (
          <div className="tb-data-blue font-bold">
            {getKeyValue(item, columnKey).includes("null")
              ? "-"
              : getKeyValue(item, columnKey)}
          </div>
        );
      case "group":
        return (
          <div className="font-bold">
            <div>{item?.Role?.name}</div>
          </div>
        );
      case "createdAt":
      case "lastLogin":
        return (
          <div className="w-max">
            <div>
              {getKeyValue(item, columnKey)
                ? format(getKeyValue(item, columnKey), "dd/MM/yyyy")
                : "-"}
            </div>
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isResettingPw ? (
        <ResetAccountPw item={editAccItemData!} onCancel={handleCancelEdit} />
      ) : isEditingAcc ? (
        <EditAccTab
          itemData={editAccItemData!}
          onCancel={handleCancelEditAcc}
        />
      ) : isAddingNewAccount ? (
        <AddAccount onCancel={handleAddNewAccountCancel} />
      ) : (
        <div>
          <div className="font-ubuntu float-left text-center text-sm font-semibold text-white sm:text-lg">
            <p className="hidden sm:block">Account List</p>
          </div>

          <Datatable
            columns={columns}
            renderCell={renderCell}
            query={query}
            customQueryFilter={[]}
            customFilters={[]}
            customActions={[
              <div className="ml-2 basis-1/2">
                <Button
                  onClick={handleAddNewAccountClick}
                  className="admin-common-button-gradient font-ubuntu w-full rounded-md text-base font-bold"
                >
                  <AddIcon />
                  Add Account
                </Button>
              </div>,
            ]}
            searchFields={fields}
          />
        </div>
      )}
    </div>
  );
};

export default AccountList;
